/* Noël : neige + apparition au scroll */
(function(){try{
  var rm=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;if(rm)return;
  var s=document.createElement("div");s.className="pk-snow";s.setAttribute("aria-hidden","true");
  var n=window.innerWidth<700?22:44;
  for(var i=0;i<n;i++){var f=document.createElement("i");f.className="pk-flake";
    f.style.cssText="--x:"+(Math.random()*100).toFixed(1)+"%;--s:"+(2+Math.random()*5).toFixed(1)+"px;--o:"+(0.35+Math.random()*0.55).toFixed(2)+";--d:"+(9+Math.random()*12).toFixed(1)+"s;--dl:-"+(Math.random()*18).toFixed(1)+"s;--dx:"+(Math.random()*80-40).toFixed(0)+"px";
    s.appendChild(f);}
  document.body.appendChild(s);
}catch(e){}})();
